<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    :value="open"
    @input="handleOpen"
    :open-on-focus="false"
    :open-on-click="true"
    :bottom="true">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        >
        <iconify-icon class="iconify" data-icon="mdi-chevron-down"></iconify-icon>
      </v-btn>
    </template>
    <template v-slot:default>
      <v-list>
        <v-list-item 
          v-for="(item, index) in Object.keys(languages)"
          :key="index"
          @click="selectHandlers[index]"
        >
          <v-list-item-title>
            {{ item}}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
import { defineComponent, ref, computed } from "vue"
  export default defineComponent({
    events: ['select-language', 'opened'],
    setup(props, context){
      const langSelected = ref('');

      const handleSelect = (langName)=>{
        handleOpen(false);
        langSelected.value = langName;
        context.emit('selected-language', langName);
      };

      const handleOpen = (value)=>{
        context.emit('update:open', value)
      };

      const selectHandlers = computed(()=>(
        Object.keys(props.languages).map((name)=>{
          return handleSelect.bind(null, name);
        })
      ))

      return {
        selectHandlers,
        handleOpen
      }
    },
    props: {
      open: {
        type: Boolean,
        required: true
      },
      languages: {
        type: Object,
        default: () => {},
      }
    }
  })
</script>

<style scoped lang="scss">
  .v-select__slot {
    padding: 10px;
  }
</style>
